import common from '@page/common/js/common';
import Vue from 'vue';
import Photos from '@page/shopContent/js/Photos.vue';
import Recommend from '@page/shopContent/js/Recommend.vue';
import Price from '@page/shopContent/js/Price.vue';
import ColorButton from '@page/shopContent/js/ColorButton.vue';
import SelectSize from '@page/shopContent/js/Select.vue';
import Quantity from '@page/shopContent/js/Ui_quantity.vue';
import BuyButton from '@page/shopContent/js/BuyButton.vue';
import Ootd from '@page/shopContent/js/ootd.vue';
import WishlistBtn from '@page/shopContent/js/WishlistBtn.vue';
import imgTransfer from '@global/helpers/imgTransfer';
import modal from 'bootstrap/js/dist/modal';
import axios from 'axios';
import Addon from '@page/shopContent/js/addon';
import IndexTemplate from '@page/shopContent/js/indexTmpl';
import SpecMobile from '@page/shopContent/js/SpecMobile.vue';
import StockMobile from '@page/shopContent/js/StockMobile.vue';
import Notice from '@page/shopContent/js/Notice.vue';
import AddToCart from '@page/shopContent/js/AddToCart.vue';
import $ from 'jquery';
import setEnv from '@global/helpers/setEnv';
import { fireShopContentView } from '@global/gtm/product';
import store from '@global/components/store/index';
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapMutations, mapActions } = createNamespacedHelpers('shopContent');

require('@global/vendors/jquery.sticky-kit');

if (process.env.NODE_ENV === 'development') {
  Vue.config.devtools = true;
}

const app = new Vue({
  el: '#product-render',
  name: 'ShopContent',
  components: {
    Photos,
    Price,
    ColorButton,
    SelectSize,
    Quantity,
    BuyButton,
    Ootd,
    Recommend,
    WishlistBtn,
    Addon,
    SpecMobile,
    StockMobile,
    Notice,
    AddToCart,
  },
  store,
  data: {
    CustomMarketID: window.CustomMarketID.substring(0, window.CustomMarketID.indexOf('CL')),
    isMobile: setEnv.myEquipment(),
    sizeReportOpened: false,
    summary: 0,
  },
  computed: {
    ...mapState([
      'selectedDataID',
      'dataIsLoad',
      'carAddMainItem',
      'CMID',
      'itemDatas',
      'selectedData',
      'selectedSpec',
      'isOpenStockDialog',
    ]),
  },
  watch: {
    selectedDataID() {
      this.getSelectedData();

      fireShopContentView({
        affiliation: this.selectedData.Name,
        customMarketID: this.itemDatas.CustomMarketID,
        eventName: this.itemDatas.Events.length ? this.itemDatas.Events[0].Name : '',
        name: this.itemDatas.Name,
        price: this.itemDatas.EventPrice > 0 ? this.itemDatas.EventPrice : this.itemDatas.SellPrice,
      });
    },
    dataIsLoad(val) {
      if (val && window.matchMedia('(min-width: 1024px)').matches) {
        this.$nextTick(() => {
          $('.product-details').stick_in_parent({ offset_top: 138 });
        });
      }
    },
  },
  created() {
    this.getData();
  },
  mounted() {
    $('body').css({ background: 'none' });
    $('#sizeGuide').modal('hide');
    this.checkIfStuck();
  },
  methods: {
    ...mapMutations(['showMobileCartDialog']),
    ...mapActions(['getData', 'getSelectedData']),
    showProductInfo(index) {
      this.summary = index;
      const $tabsContentDiv = $('.tabs__content >div');
      $tabsContentDiv.addClass('hide');
      $tabsContentDiv.eq(index).removeClass('hide');
      $('.product-details').trigger('sticky_kit:recalc');
    },
    openPopup() {
      $('.size-guide__section').each(function () {
        if (!$(this).find('td').length) {
          $(this).hide();
        }
      });
      if (this.isMobile) {
        this.showProductInfo(2);
        return;
      }
      $('#size-report').modal('show');

      if (!this.sizeReportOpened) {
        $('.size-guide__content').hide();
        $('.size-guide').find('.size-guide__content').eq(0).show();
        $('.size-guide__section>h2').click(function () {
          $(this).parents('.size-guide__section').siblings().find('.size-guide__content').slideUp();
          $(this).parents('.size-guide__section').find('.size-guide__content').slideToggle();
        });
        this.sizeReportOpened = true;
      }
    },
    checkIfStuck() {
      // 因為商品頁右側有時候會空白,因此加上這個防範機制
      const isStuck = $('.product-details').hasClass('is_stuck');

      if (isStuck) {
        $('.product-details').css('position', 'fixed');
        $('.product-details').css('top', '138px');
      } else {
        setTimeout(this.checkIfStuck, 100);
      }
    },
  },
  template: IndexTemplate,
});

window.pazzo.productConfig = {
  stickyListMenu: true,
  templateVersion: 1,
  hasWishList: true,
  sizeSelectorTypeDesktop: 'dropdown',
  imageBasePath: '//cdn.pazzo.com.tw/',
  zoomboxData: 'JumboImage',
  moreJumboImage: '.product-photos__images',
  imageRenderType: 'sliceFirst',
  refreshDOMs: ['.product-photos__jumbo', '.product-photos__images', '.product-size'],
};

const hasMarquee = $('.pazzo-footer-marquee')[0];

document.body.addEventListener('touchmove', function touchMove(e) {
  e.preventDefault();
  $('#bottom-bar').css('display', 'flex');
  if (setEnv.myEquipment() && hasMarquee) {
    $('.pazzo-footer-marquee').css('z-index', '0');
  }
});

window.addEventListener('mousemove', function mouseMove(e) {
  $('#bottom-bar').css('display', 'flex');
  if (setEnv.myEquipment() && hasMarquee) {
    $('.pazzo-footer-marquee').css('z-index', '0');
  }
});
